// Central source of truth for the 4-pillar system.
// DB slugs (backend) → public keys / labels used in the pricing model & UI.
//
// Yoga         (key: 'yoga')     ↔ DB slug 'spirituality'  — one-time fee
// Learning     (key: 'learning') ↔ DB slug 'activities'    — one-time fee
// Working      (key: 'working')  ↔ DB slug 'work'          — always $0
// Sharing      (key: 'sharing')  ↔ DB slug 'sharing'       — volunteer $0 OR paid masterclass

export const PILLAR_DEFS = [
  { key: "yoga",     slug: "spirituality", label: "Yoga",     description: "One-time fee, set by host" },
  { key: "learning", slug: "activities",   label: "Learning", description: "One-time fee, set by host" },
  { key: "working",  slug: "work",         label: "Working",  description: "Personal jobs or assignments" },
  { key: "sharing",  slug: "sharing",      label: "Sharing",  description: "Volunteer free · or paid masterclass" },
];

export const PILLAR_LABEL_BY_SLUG = Object.fromEntries(PILLAR_DEFS.map(p => [p.slug, p.label]));
export const PILLAR_LABEL_BY_KEY = Object.fromEntries(PILLAR_DEFS.map(p => [p.key, p.label]));
export const PILLAR_KEY_BY_SLUG = Object.fromEntries(PILLAR_DEFS.map(p => [p.slug, p.key]));
export const PILLAR_SLUG_BY_KEY = Object.fromEntries(PILLAR_DEFS.map(p => [p.key, p.slug]));

export function pillarFeeFor(key, pricing, sharingMode) {
  if (!pricing) return 0;
  if (key === "yoga") return Number(pricing.yoga_fee || 0);
  if (key === "learning") return Number(pricing.learning_fee || 0);
  if (key === "working") return 0;
  if (key === "sharing") {
    const mode = sharingMode || pricing.sharing_mode || "volunteer";
    return mode === "masterclass" ? Number(pricing.sharing_masterclass_fee || 0) : 0;
  }
  return 0;
}
